import { render, staticRenderFns } from "./activity_data_statistics.vue?vue&type=template&id=0c798ca3&scoped=true"
import script from "./activity_data_statistics.vue?vue&type=script&lang=js"
export * from "./activity_data_statistics.vue?vue&type=script&lang=js"
import style0 from "./activity_data_statistics.vue?vue&type=style&index=0&id=0c798ca3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c798ca3",
  null
  
)

export default component.exports